<template>
	<div >
		<div class="p_m_b_20" v-for="(item,index) in 4" :key="index">
			 <el-checkbox :label="index" :checked="radio == index" name="type">
			 	B. 樊哙闯帐后，按剑而跽，瞠目啖肉，义责项羽。作者以夸张的语气、漫画的笔触，勾勒了一个霸气逼人的怒目金刚形象。
			 </el-checkbox>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			radio:0
		};
	},
	mounted() {},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
	>>> .el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: #00af63;
		background: #00af63;
	}
	>>> .el-checkbox__input.is-checked + .el-checkbox__label {
		color: #333333;
	}
	>>> .el-checkbox__inner {
		width: 18px;
		height: 18px;
	}
	>>> .el-checkbox__label {
		font-size: 18px;
	}
	>>> .el-checkbox__inner:hover {
		border-color: #999999;
	}
	>>> .el-checkbox__inner::after {
		height: 9px;
		left: 6px;
		top: 1px;
		width: 4px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/more.vue